export default {
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '50px',
  },
  exitSelectContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  exitSelect: {
    width: '40%',
  },
  exitSearchAncestorTitle: {
    fontSize: '15px',
    marginRight: '10px',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  modalPaperRoot: {
    maxWidth: '1200px',
  },
};
